import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";

class ProfileFormPresenter extends BaseFormPresenter {
  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    this.change.affiliate = { id: this.change.affiliate.id };
    this.change.approvedBy = { id: this.change.approvedBy.id };
    this.change.branch = { id: this.change.branch.id };
    this.change.roles = this.change.roles.map((role) => ({ id: role.id }));

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }
  async submit() {
    const { password, confirmPassword, roles, ...others } = this.object;
    const currentUser = this.view.getCurrentUser();

    if (password !== confirmPassword) {
      this.view.showError("password must be the same");
      return;
    }
    this.change = {
      ...(password ? { password } : {}),
      roles: Array.isArray(roles) ? roles : [roles],
      status: "Active",
      registrationStatus: "Approved",
      approvedBy: currentUser,
      ...others,
    };

    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      await this.view.showConfirmationDialog();
      await this.save();
      this.view.submissionSuccess();
      toast.success("Successfully saved!", { position: "top-right" });
      this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default ProfileFormPresenter;
